import { useState } from "react";
import { Box, Button, Group, Modal, Text } from "@mantine/core";

type QuickRecordConfirmDeleteModalProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean | null) => void;
  title: string;
  description: string;
  onConfirm: () => void;
  deleting: boolean;
};

const QuickRecordConfirmDeleteModal = (
  props: QuickRecordConfirmDeleteModalProps,
) => {
  const [errorMsg, setErrorMsg] = useState<string>("");
  const {
    modalOpened,
    setModalOpened,
    onConfirm,
    deleting,
    title,
    description,
  } = props;

  return (
    <Modal
      opened={modalOpened}
      onClose={() => {
        setErrorMsg("");
        setModalOpened(null);
      }}
      title={title}
    >
      <Box>
        <Text fw={400} fz={14}>
          {description}
        </Text>
        {errorMsg && (
          <Text fw={400} fz={14} c="red">
            {errorMsg}
          </Text>
        )}
      </Box>
      <Group mt="md">
        <Group mt="md">
          <Button variant="default" onClick={() => setModalOpened(null)}>
            No
          </Button>
          <Button
            loading={deleting}
            disabled={deleting}
            onClick={() => onConfirm()}
          >
            Yes
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};

export default QuickRecordConfirmDeleteModal;
